export default {

  setJustAcceptedOffer (state, value) {
    state.justAcceptedOffer = value
  },

  setCurrentView (state, value) {
    state.currentView = value
  },

  setOffer (state, value) {
    state.offer = value
  },

  setProduct (state, value) {
    state.product = value
  },
  setIsFirstOffer (state, value) {
    state.isFirstOffer = value
  },
  setDialog (state, value) {
    state.dialog = value
  },
  setDecreasingCounterOffer (state, value) {
    state.decreasingCounterOffer = value
  },
  setMaxCounterOffer (state, value) {
    state.maxCounterOffer = value
  },
  setBuyer (state, value) {
    state.buyer = value
  }

}
